module.exports = "mutation UpdateBanner($data:BannerInput!){updateBanner(data:$data){success}}"